import React, { useContext } from "react";
import ImageContainer from "@components/imageContainer";
import { Flex } from "@acko-tech/building-blocks.ui.common";
import styled from "styled-components";
import { resolvePath } from "@utils/resolvePath";
import { Context } from "@components/useContext/context";
import DOMPurify from "isomorphic-dompurify";
import { toReadableList } from "@utils/index";

interface ContainerProps {
  gap?: string;
}

const Container = styled(Flex)<ContainerProps>`
  top: -20px;
  position: relative;
  flex-direction: column;
  box-sizing: border-box;
  color: #36354c;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  width: 100%;
  z-index: 1;
  gap: ${(props) => props.gap || "0px"};
  span {
    font-weight: 600;
  }
`;

const Wrapper = styled.div`
  background-repeat: no-repeat;
  background-size: cover;
  position: absolute;
  top: 0px;
  width: 100vw;
  height: 160px;
  left: 0px;
  right: 0px;
  pointer-events: none;
  ${(props: { isGradient: any; }) =>
    props.isGradient ?
      `
      background-image: url(${resolvePath("/images/Yellow.svg")});
      height: 216px;
    ` : `background-image: url(${resolvePath("/images/Green.svg")});`}
    ;
  }
`;

const Question = styled(Flex)`
  font-size: 18px;
  color: #040222;
  font-weight: 500;
`;

interface ParaProps {
  isDesktop?: boolean;
}

const Para = styled(Flex)<ParaProps>`
  display: inline;
  font-size: ${(props) => props.isDesktop ? '14px' : '12px'};
  line-height: 18px;
  width: 90%;
`;

const GradientHeader = (props) => {
  const { isGradient = true } = props || {};
  const { isDesktop } = useContext(Context);
  return isDesktop ? null :  <Wrapper isGradient={isGradient} />;
};

const QWithImageNDesc = (props) => {
  const {
    question,
    gap,
    error_code,
    previousPlanExpiredMessage,
    previousPlanClaimsMessage,
    carAgeExceedsLimitMessage,
    src,
    height,
    width,
    styles,
    addonNotEligible,
    addonNotEligibleMessage,
    is_visible
  } = props || {};

  const { isDesktop } = useContext(Context);

  let displayMessage = "";
  if (error_code === "PartialBlockPreviousPlanExpired") {
    displayMessage = previousPlanExpiredMessage;
  } else if (error_code === "PartialBlockPreviousPlanClaims") {
    displayMessage = previousPlanClaimsMessage;
  } else if (error_code === "PartialBlockCarAgeLimitExceeded") {
    displayMessage = carAgeExceedsLimitMessage;
  }

  return is_visible ? (
    <>
      <GradientHeader/>
        <Container gap={gap}>
          <Flex
            justifyContent="space-between"
            alignItems="center"
            style={{ width: "100%" }}
          >
            <Question
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(question || "")
              }}
            />
            <ImageContainer
              imgSrc={src}
              alt=""
              height={height}
              width={width}
              styles={styles}
            />
          </Flex>
          {(displayMessage || (Array.isArray(addonNotEligible) && addonNotEligible.length > 0 && addonNotEligibleMessage)) && (
          <>
            {displayMessage && (
              <Para
                isDesktop={isDesktop}
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(displayMessage)
                }}
              />
            )}
            {Array.isArray(addonNotEligible) && addonNotEligible.length > 0 && addonNotEligibleMessage && (
                <Para
                  style={{ marginTop: displayMessage ? "10px" : "0px" }}
                  isDesktop={isDesktop}
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(
                      addonNotEligibleMessage.replace(
                        "${addonNotEligible}",
                        toReadableList(addonNotEligible)
                      )
                    )
                  }}
                />
              )}
          </>
        )}
        </Container>
    </>
  ):null;
};

export default QWithImageNDesc;